export default "__VITE_ASSET__BpM8TOWJ__"